import MyFile from './my_file'

export default MyFile
